import type { SlideProps } from "@/engine/app/offsite-config";

// Quelle: Make.com Org "SVO" (eu2), Stand 16.09.2026 — 45 Szenarien,
// 30 aktiv, 7.043 Operationen seit Abrechnungsbeginn 02.09.
const STATS = [
  { value: "30", label: "Make-Szenarien aktiv im Betrieb" },
  { value: "7.000+", label: "Automatisierungs-Schritte allein seit Monatsbeginn" },
  { value: "0", label: "Doppelerfassungen auf diesem Weg" },
];

export function Slide04Nutzen(_: SlideProps) {
  return (
    <div className="deck-root dark" style={{ background: "var(--svo-dunkelblau)" }}>
      <div className="deck-bg" aria-hidden="true" />
      <div
        className="float"
        aria-hidden="true"
        style={{
          width: 380,
          height: 380,
          top: "-100px",
          right: "-100px",
          background: "var(--svo-blau)",
          opacity: 0.28,
        }}
      />

      <header className="deck-head">
        <div className="deck-eyebrow rise rise-1">Was es bringt</div>
        <h1 className="deck-title rise rise-2">
          Zeit für das, <br />
          <span className="accent">was zählt</span>
        </h1>
      </header>

      <div className="deck-big">
        <div className="big-grid rise rise-4">
          {STATS.map((s, i) => (
            <div key={s.label} className="big-tile">
              <div className="tile-eyebrow">0{i + 1}</div>
              <div className="tile-value">{s.value}</div>
              <div className="tile-label">{s.label}</div>
            </div>
          ))}
        </div>
      </div>

      <footer className="deck-foot">
        <span>Und wo bleibt dabei der Mensch? — Genau darum geht es jetzt.</span>
      </footer>
    </div>
  );
}
